<template>
  <div class="custom-wrapper" :class="{active: visible || visible2 || visible3}">
    <div class="position: relative;">
      <!-- .custom-link-type-1 === ctt1 -->
      <popper :show-popper="visible" @close="visible=false" placement="right-start" :index="index">
        <div class="ctt1" @click.prevent="setVisible()">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{linkModal}}</div> -->
          <div class="ctt1-box custom-item">
            <!-- 内容 -->
            <div style="padding: 10px;">
              <div v-if="!linkFlag" class="linkText">点击编辑一条<关联链接></div>
              <div v-else>
                <div v-for="(item,index) in linkModal" :key="index" class="linkText">
                  <!-- <span v-if="item.type == '0'"></span> -->
                  <span>{{item.name}}</span>
                  <i class="icon iconfont icon-xiangshang" style="transform:rotate(90deg);"></i>
                </div>
              </div>
              <!-- <div v-else :style="{'width':'100%'}">{{linkModal[0].name}}</div> -->
            </div>

            <!-- 关闭按钮 -->
            <i class="icon iconfont icon-close-c custom-close" @click="close()"></i>
          </div>
        </div>
        <div slot="content" class="ctt1-poptip">
          <div class="ctt1p-title">链接设置</div>
          <!-- 设置内容 -->
          <div class="ctt1p-content">
            <div
              v-for="(item,index) in linkList"
              :key="'addLink' + index"
              class="ctt1p-content-wrapper"
              :class="{first: index === 0}"
            >
              <addLink v-model="item.data" :ref="'addLink' + index" @popperHide="popperHide" />
              <i class="icon iconfont icon-close-c custom-close" @click="delItem(index)"></i>
            </div>
            <div class="addlink" @click="addLink">
              <i class="icon iconfont icon-add2"></i>添加一个关联链接
            </div>
          </div>
        </div>
      </popper>
      <!-- 上方增加键 -->
      <Poptip
        v-model="visible2"
        placement="right-start"
        width="411"
        class="custom-add-wrapper z-top"
      >
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr"
                :key="'commmon-' + index"
                @click="add(item, 'top')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
      <!-- 下方增加键 -->
      <Poptip
        v-model="visible3"
        placement="right-start"
        width="411"
        class="custom-add-wrapper z-bottom"
      >
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr"
                :key="'commmon-' + index"
                @click="add(item, 'bottom')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import addLink from "./add-link-item.vue";
import popper from "@components/vue-popper/VuePopper.vue";

export default {
  // 链接类型
  name: "custom-link-type",
  model: {
    prop: "linkModal",
    event: "sendLinkModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    linkModal: {
      type: Array,
      default: function() {
        return [
          {
            type: "", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
            name: "",
            url: ""
          }
        ];
      }
    }
  },
  data() {
    return {
      visible: false,
      visible2: false,
      visible3: false,
      linkFlag: false,


      commmonArr: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "标题",
          icon: "icon-biaoti",
          type: "title",
          componentName: "customTitle",
          config: {
            type: 1, // 标题类型 暂时只有 1
            content: "",
            position: "left", // 文本对齐格式
            padding: "12px", // 标题的边距
            fontSize: "12px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色
            link: {
              type: "3",
              value: ""
            }
          }
        },
        {
          title: "链接",
          icon: "icon-link",
          type: "link",
          componentName: "customLink",
          config: [{
            type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
            name: "",
            url: ""
          }]
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: ["热词1", "热词2"],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            background: "#f5f5f5",
            borderColor: "#91c0ec"
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      commmonArr2: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      
      tag: "",
      linkList: [
        {
          modal: "",
          data: {
            type: "", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
            name: "",
            url: "",
            Count: ""
          }
        }
      ]
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      if (val !== this.index) this.visible = false;
    },
    linkModal(val, oldVal) {
      // val.map(c => {
      //   if (c.type) {
      //     this.linkFlag = true;
      //   } else {
      //     this.linkFlag = false;
      //   }
      // })
      if (val[0].type) {
        this.linkFlag = true;
      } else {
        this.linkFlag = false;
      }
    }
  },
  computed: {
    type() {
      return this.info.type;
    },
    ...mapGetters({
      activeIndex: "customComponentModule/getActiveIndex"
    })
  },
  created() {
    if (this.index === this.activeIndex) {
      this.visible = true;
    }
    if (this.linkModal.length) {
      let arr = [];
      this.linkModal.forEach((val, index) => {
        arr.push({
          modal: "addLink" + index,
          data: {
            type: val.type, // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
            name: val.name,
            url: val.url,
            Count: val.Count
          }
        });
      });
      this.linkList = arr;
    }
    if (this.linkModal.length) {
      this.linkModal.map(c => {
        if (c.type) {
          this.linkFlag = true;
        }
      })
    }
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
      this.popperHide();
    },
    addComponent() {
      this.visible = false;
    },
    add(item, index) {
      // top 表示在上面添加  bottom表示下面添加
      let idx = this.index;
      if (index === "bottom") {
        idx = this.index + 1;
      }
      this.$emit("add", item, idx);
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false; 
    },
    close() {
      this.$emit("close");
    },
    addLink() {
      const num = this.linkList.length;
      this.linkList.push({
        modal: "addLink" + num,
        data: {
          type: "", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
          name: "",
          url: "",
          Count: ""
        }
      });
      let arr = [];
      this.linkList.forEach(c => {
        arr.push(c.data);
      });
      this.$emit("change", arr);
    },
    popperHide() {
      let arr = [];
      this.linkList.forEach(c => {
        arr.push(c.data);
      });
      this.$emit("change", arr);
    },
    delItem(index) {
      this.linkList.splice(index,1);
      let arr = [];
      this.linkList.forEach(c => {
        arr.push(c.data);
      });
      this.$emit("change", arr); 
    }
  },
  components: {
    addLink,
    popper
  },
  mounted() {
    if (this.index === 0) {
      this.visible = true;
      this.setActiveIndex(this.index);
    }
  }
};
</script>

<style lang="scss">
.ivu-select-dropdown {
  width: 130px;
}
</style>
<style scoped lang="scss">
.ctt1 {
  width: 100%;
  &-box {
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .ctt1p {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-content {
        padding: 20px 20px;
        &-wrapper {
          position: relative;
          &.first {
            .custom-close {
              display: none;
            }
          }
          .custom-close {
            right: -32px;
            top: 50%;
            margin-top: -19px;
            color: #dd514c;
            font-size: 24px;
            cursor: pointer;
          }
        }
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.linkText {
  width: 100%;
  display: flex;
  color: #333;
  // border-bottom: 1px solid #dddddd;
  align-items: center;
  padding: 5px 0;
  span {
    flex: 1;
  }
  i {
    width: 20px;
    color: #b2b2b2;
  }
}
</style>
